import { Component, computed, input } from '@angular/core';
import { NavService } from '@app/core/services/nav.service';
import { INavList, INavItem } from '../../interfaces/navigation.interface';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  standalone: false,
})
export class NavigationItemComponent {
  navItem = input<INavItem>();
  navList = input<INavList>();
  isNested = input<boolean>(false);

  readonly NAV_LIST_TYPE = 'navList';
  readonly NESTED_NAV_ITEM_TYPE = 'nestedNavItem';
  readonly NAV_ITEM_TYPE = 'navItem';

  // Computed signal to determine which template to use
  itemType = computed(() => {
    if (this.navList()) {
      return this.NAV_LIST_TYPE;
    }

    if (this.navItem() && this.isNested()) {
      return this.NESTED_NAV_ITEM_TYPE;
    }

    if (this.navItem()) {
      return this.NAV_ITEM_TYPE;
    }

    return null;
  });

  isListExpanded = computed(() => {
    return (
      this.itemType() === this.NAV_LIST_TYPE &&
      this.navService.isSelectedList(this.navList()?.label)
    );
  });

  constructor(public navService: NavService) {}

  onNavItemSelect(item: INavItem): void {
    this.navService.selectItem(item);
    this.navService.selectList(null);
    this.navService.closeMobileMenu();
  }

  onNavListSelect(list: INavList): void {
    this.navService.selectList(list);
  }

  onNestedNavItemSelect(item: INavItem): void {
    this.navService.selectItem(item);
    this.navService.closeMobileMenu();
  }
}
